import { ContentReferenceType } from "../../../types/ContentReferenceType";
import { OrderContentReference } from "../../../types/OrderContentReference";
import { renderBrandedContentVersionText, renderContentVersionText } from "../../../utils/renderContentVersionText";

export const resolveOrderContentTitle = (content: OrderContentReference): string => {
    switch (content.type) {
        case ContentReferenceType.Movie: {
            return content.movie.title;
        }
        case ContentReferenceType.TvSeries: {
            return `${content.tvSeries.title} - ${content.season.name} - ${content.episode.title} - (Ep. ${content.episode.number})`;
        }
        case ContentReferenceType.Ancillary: {
            return content.ancillary.title;
        }
        default:
            throw new Error("Incorrect Content Type.");
    }
};

export const resolveOrderContentVersion = (content: OrderContentReference): string => {
    switch (content.type) {
        case ContentReferenceType.Movie:
        case ContentReferenceType.TvSeries: {
            return renderBrandedContentVersionText(content.version);
        }

        case ContentReferenceType.Ancillary: {
            return renderContentVersionText({
                distributor: content.version.distributor,
                type: content.version.type,
                airlines: content.version.airlines
            });
        }

        default:
            throw new Error("Incorrect Content Type.");
    }
};
